var map = {
	"./img-Idagunji-carousal-1.webp": 35805,
	"./img-Idagunji-carousal-2.webp": 92976,
	"./img-Idagunji-carousal-3.webp": 18739,
	"./img-Idagunji-carousal-4.webp": 73454,
	"./img-apsarakonda-carousal-1.webp": 86803,
	"./img-apsarakonda-carousal-2.webp": 79154,
	"./img-apsarakonda-carousal-3.webp": 3869,
	"./img-apsarakonda-carousal-4.webp": 43276,
	"./img-basavarayana-durga-carousal-1.webp": 96208,
	"./img-basavarayana-durga-carousal-2.webp": 4861,
	"./img-basavarayana-durga-carousal-3.webp": 44946,
	"./img-basavarayana-durga-carousal-4.webp": 10255,
	"./img-chaturmukha-carousal-1.webp": 87455,
	"./img-chaturmukha-carousal-2.webp": 75518,
	"./img-chaturmukha-carousal-3.webp": 60025,
	"./img-chaturmukha-carousal-4.webp": 21824,
	"./img-haigunda-carousal-1.png": 31677,
	"./img-haigunda-carousal-1.webp": 20901,
	"./img-haigunda-carousal-2.webp": 20152,
	"./img-haigunda-carousal-3.webp": 79323,
	"./img-haigunda-carousal-4.webp": 10966,
	"./img-kandla-walk-carousal-1.webp": 38689,
	"./img-kandla-walk-carousal-2.webp": 4164,
	"./img-kandla-walk-carousal-3-1.webp": 70105,
	"./img-kandla-walk-carousal-3.webp": 68199,
	"./img-mirjan-carousal-1.webp": 27243,
	"./img-mirjan-carousal-2.webp": 34250,
	"./img-mirjan-carousal-3.webp": 79765,
	"./img-mirjan-carousal-4.webp": 63684,
	"./img-murudeshwara-carousal-1.webp": 29882,
	"./img-murudeshwara-carousal-2.webp": 9403,
	"./img-murudeshwara-carousal-3.webp": 66584,
	"./img-murudeshwara-carousal-4.webp": 5777,
	"./img-ombeach-gokarna-carousal-1.webp": 80923,
	"./img-ombeach-gokarna-carousal-2.webp": 58554,
	"./img-ombeach-gokarna-carousal-3.webp": 22725,
	"./img-ombeach-gokarna-carousal-4.webp": 78740,
	"./img-yana-carousal-1.webp": 32665,
	"./img-yana-carousal-2.webp": 52988,
	"./img-yana-carousal-3.webp": 31231,
	"./img-yana-carousal-4.webp": 49794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85805;